//   // "use client";

//   // import { useState, useEffect } from "react";
//   // import apiClient from "../../context/apiClient";
//   // import {
//   //   Grid,
//   //   Typography,
//   //   TextField,
//   //   Button,
//   //   Box,
//   //   FormControl,
//   //   Select,
//   //   MenuItem,
//   //   Chip,
//   //   Divider,
//   //   Paper,
//   //   CircularProgress,
//   //   Container,
//   //   Stack,
//   //   IconButton,
//   //   InputLabel,
//   //   Skeleton,
//   // } from "@mui/material";
//   // import { useTheme } from "@mui/material/styles";
//   // import { Add, Edit, Save, Visibility } from "@mui/icons-material";
//   // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//   // import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
//   // import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//   // import Layout from "../common/Layout";
//   // import { useNotification } from "../../context/NotificationContext";

//   // const JobPosting = () => {
//   //   const theme = useTheme();
//   //   const { showNotification } = useNotification();

//   //   const initialJobData = {
//   //     title: "",
//   //     companyName: "",
//   //     contactEmail: "",
//   //     location: "",
//   //     jobType: "",
//   //     experience: "",
//   //     salaryMin: "",
//   //     salaryMax: "",
//   //     currency: "USD",
//   //     description: "",
//   //     requirements: [],
//   //     benefits: [],
//   //     skills: [],
//   //     applicationDeadline: null,
//   //     visaSponsorship: false,
//   //     remoteWork: false,
//   //   };

//   //   const [loading, setLoading] = useState(false);
//   //   const [isPageLoading, setIsPageLoading] = useState(true);
//   //   const [isPreviewing, setIsPreviewing] = useState(false);
//   //   const [jobData, setJobData] = useState(initialJobData);
//   //   const [newRequirement, setNewRequirement] = useState("");
//   //   const [newBenefit, setNewBenefit] = useState("");
//   //   const [newSkill, setNewSkill] = useState("");

//   //   useEffect(() => {
//   //     const timer = setTimeout(() => setIsPageLoading(false), 1000);
//   //     return () => clearTimeout(timer);
//   //   }, []);

//   //   const skillOptions = [
//   //     "Python",
//   //     "Machine Learning",
//   //     "Deep Learning",
//   //     "TensorFlow",
//   //     "PyTorch",
//   //     "NLP",
//   //     "Computer Vision",
//   //     "Data Science",
//   //     "AWS",
//   //     "Azure",
//   //     "GCP",
//   //     "Kubernetes",
//   //     "Docker",
//   //     "React",
//   //     "Node.js",
//   //     "SQL",
//   //     "NoSQL",
//   //   ];
//   //   const jobTypeDisplayMapping = {
//   //     "full-time": "Full-time",
//   //     "part-time": "Part-time",
//   //     contract: "Contract",
//   //     freelance: "Freelance",
//   //   };
//   //   const experienceDisplayMapping = {
//   //     entry: "Entry Level (0-2 years)",
//   //     mid: "Mid Level (3-5 years)",
//   //     senior: "Senior Level (5+ years)",
//   //     lead: "Lead/Principal (8+ years)",
//   //   };

//   //   const handleInputChange = (field, value) =>
//   //     setJobData((prev) => ({ ...prev, [field]: value }));
//   //   const handleAddItem = (field, value, setter) => {
//   //     if (value.trim()) {
//   //       setJobData((prev) => ({
//   //         ...prev,
//   //         [field]: [...prev[field], value.trim()],
//   //       }));
//   //       setter("");
//   //     }
//   //   };
//   //   const handleSkillAdd = (skill) => {
//   //     if (skill && !jobData.skills.includes(skill)) {
//   //       setJobData((prev) => ({ ...prev, skills: [...prev.skills, skill] }));
//   //     }
//   //   };
//   //   const handleRemoveItem = (field, index) =>
//   //     setJobData((prev) => ({
//   //       ...prev,
//   //       [field]: prev[field].filter((_, i) => i !== index),
//   //     }));

//   //   const handleSubmit = async (status) => {
//   //     if (!jobData.title || !jobData.location || !jobData.description) {
//   //       showNotification(
//   //         "Please fill in all required fields: Title, Location, and Description",
//   //         "error"
//   //       );
//   //       return;
//   //     }
//   //     if (!jobData.jobType || !jobData.experience) {
//   //       showNotification(
//   //         "Please select a Job Type and Experience Level.",
//   //         "error"
//   //       );
//   //       return;
//   //     }
//   //     setLoading(true);
//   //     const deadline = jobData.applicationDeadline
//   //       ? new Date(jobData.applicationDeadline).toISOString().split("T")[0]
//   //       : null;
//   //     const payload = {
//   //       title: jobData.title,
//   //       description: jobData.description,
//   //       responsibilities: jobData.description,
//   //       requirements: jobData.requirements,
//   //       location: jobData.location,
//   //       job_type: jobTypeDisplayMapping[jobData.jobType],
//   //       experience_level: {
//   //         entry: "Entry-level",
//   //         mid: "Mid-level",
//   //         senior: "Senior-level",
//   //         lead: "Lead/Principal",
//   //       }[jobData.experience],
//   //       salary_currency: jobData.currency,
//   //       salary_min: jobData.salaryMin ? parseFloat(jobData.salaryMin) : null,
//   //       salary_max: jobData.salaryMax ? parseFloat(jobData.salaryMax) : null,
//   //       benefits: jobData.benefits,
//   //       required_skills: jobData.skills,
//   //       visa_sponsorship: jobData.visaSponsorship,
//   //       remote_work: jobData.remoteWork,
//   //       status: status,
//   //       application_deadline: deadline,
//   //     };

//   //     try {
//   //       await apiClient.post("/job-postings/", payload);
//   //       showNotification(
//   //         status === "DRAFT" ? "Job saved as draft!" : "Job posted successfully!",
//   //         "success"
//   //       );
//   //       if (status === "PUBLISHED") setIsPreviewing(false);
//   //       setJobData(initialJobData);
//   //       setNewRequirement("");
//   //       setNewBenefit("");
//   //       setNewSkill("");
//   //     } catch (error) {
//   //       console.error("Failed to post job:", error);
//   //       let errorMessage = "Failed to post job.";
//   //       if (error.response?.data) {
//   //         const errors = error.response.data;
//   //         const firstErrorKey = Object.keys(errors)[0];
//   //         errorMessage = `${firstErrorKey}: ${
//   //           Array.isArray(errors[firstErrorKey])
//   //             ? errors[firstErrorKey][0]
//   //             : errors[firstErrorKey]
//   //         }`;
//   //       }
//   //       showNotification(errorMessage, "error");
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   const SectionTitle = ({ children }) => (
//   //     <Typography
//   //       variant="h6"
//   //       fontWeight="bold"
//   //       sx={{ color: "primary.main" }}
//   //       gutterBottom
//   //     >
//   //       {children}
//   //     </Typography>
//   //   );

//   //   const formPaperStyles = {
//   //     p: { xs: 2, md: 3 },
//   //     borderRadius: "12px",
//   //     backgroundColor: theme.palette.mint.main,
//   //     boxShadow: theme.shadows[1],
//   //   };

//   //   if (isPageLoading) {
//   //     return (
//   //       <Layout title="Post New Job">
//   //         <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//   //           <Stack spacing={3}>
//   //             <Skeleton
//   //               variant="rectangular"
//   //               height={100}
//   //               sx={{ borderRadius: "12px" }}
//   //             />
//   //             <Skeleton
//   //               variant="rectangular"
//   //               height={600}
//   //               sx={{ borderRadius: "12px" }}
//   //             />
//   //           </Stack>
//   //         </Container>
//   //       </Layout>
//   //     );
//   //   }

//   //   if (isPreviewing) {
//   //     return (
//   //       <Layout title="Preview Job Posting">
//   //         <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//   //           <Paper elevation={0} sx={formPaperStyles}>
//   //             <Stack spacing={4}>
//   //               <Box>
//   //                 <Typography variant="h4" component="h1" fontWeight="bold">
//   //                   {jobData.title}
//   //                 </Typography>
//   //                 <Typography variant="h6" color="text.secondary">
//   //                   {jobData.companyName} - {jobData.location}
//   //                 </Typography>
//   //               </Box>
//   //               <Divider />
//   //               <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
//   //                 {jobData.description}
//   //               </Typography>
//   //               <Grid container spacing={4}>
//   //                 <Grid item xs={12} md={6}>
//   //                   <SectionTitle>Requirements</SectionTitle>
//   //                   <Stack spacing={1}>
//   //                     {jobData.requirements.map((item, index) => (
//   //                       <Typography key={index} variant="body1">
//   //                         • {item}
//   //                       </Typography>
//   //                     ))}
//   //                   </Stack>
//   //                 </Grid>
//   //                 <Grid item xs={12} md={6}>
//   //                   <SectionTitle>Benefits</SectionTitle>
//   //                   <Stack spacing={1}>
//   //                     {jobData.benefits.map((item, index) => (
//   //                       <Typography key={index} variant="body1">
//   //                         • {item}
//   //                       </Typography>
//   //                     ))}
//   //                   </Stack>
//   //                 </Grid>
//   //               </Grid>
//   //               <Box>
//   //                 <SectionTitle>Required Skills</SectionTitle>
//   //                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//   //                   {jobData.skills.map((skill, index) => (
//   //                     <Chip key={index} label={skill} />
//   //                   ))}
//   //                 </Box>
//   //               </Box>
//   //               <Divider />
//   //               <Box>
//   //                 <SectionTitle>Additional Information</SectionTitle>
//   //                 <Grid container spacing={2}>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <Typography fontWeight="bold">Job Type:</Typography>
//   //                     <Typography>
//   //                       {jobTypeDisplayMapping[jobData.jobType] ||
//   //                         jobData.jobType}
//   //                     </Typography>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <Typography fontWeight="bold">Experience Level:</Typography>
//   //                     <Typography>
//   //                       {experienceDisplayMapping[jobData.experience] ||
//   //                         jobData.experience}
//   //                     </Typography>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <Typography fontWeight="bold">Salary:</Typography>
//   //                     <Typography>
//   //                       {jobData.salaryMin && jobData.salaryMax
//   //                         ? `${jobData.salaryMin} - ${jobData.salaryMax} ${jobData.currency}`
//   //                         : "Not Disclosed"}
//   //                     </Typography>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <Typography fontWeight="bold">
//   //                       Application Deadline:
//   //                     </Typography>
//   //                     <Typography>
//   //                       {jobData.applicationDeadline
//   //                         ? new Date(
//   //                             jobData.applicationDeadline
//   //                           ).toLocaleDateString()
//   //                         : "N/A"}
//   //                     </Typography>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <Typography>
//   //                       Visa Sponsorship: {jobData.visaSponsorship ? "Yes" : "No"}
//   //                     </Typography>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <Typography>
//   //                       Remote Work: {jobData.remoteWork ? "Yes" : "No"}
//   //                     </Typography>
//   //                   </Grid>
//   //                 </Grid>
//   //               </Box>
//   //               <Stack
//   //                 direction={{ xs: "column", sm: "row" }}
//   //                 spacing={2}
//   //                 justifyContent="flex-end"
//   //                 sx={{ pt: 3 }}
//   //               >
//   //                 <Button
//   //                   variant="outlined"
//   //                   color="primary"
//   //                   startIcon={<Edit />}
//   //                   onClick={() => setIsPreviewing(false)}
//   //                 >
//   //                   Back to Edit
//   //                 </Button>
//   //                 <Button
//   //                   variant="outlined"
//   //                   color="secondary"
//   //                   startIcon={<Save />}
//   //                   disabled={loading}
//   //                   onClick={() => handleSubmit("DRAFT")}
//   //                 >
//   //                   Save as Draft
//   //                 </Button>
//   //                 <Button
//   //                   variant="contained"
//   //                   color="primary"
//   //                   startIcon={
//   //                     loading ? (
//   //                       <CircularProgress size={20} color="inherit" />
//   //                     ) : (
//   //                       <Save />
//   //                     )
//   //                   }
//   //                   disabled={loading}
//   //                   onClick={() => handleSubmit("PUBLISHED")}
//   //                 >
//   //                   Publish Job
//   //                 </Button>
//   //               </Stack>
//   //             </Stack>
//   //           </Paper>
//   //         </Container>
//   //       </Layout>
//   //     );
//   //   }

//   //   return (
//   //     <Layout title="Post New Job">
//   //       <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//   //         <Stack spacing={3}>
//   //           <Paper elevation={0} sx={formPaperStyles}>
//   //             <Box>
//   //               <Typography
//   //                 variant="h5"
//   //                 component="h1"
//   //                 fontWeight="bold"
//   //                 color="primary.main"
//   //               >
//   //                 Create a New Job Posting
//   //               </Typography>
//   //               <Typography variant="body2" color="text.secondary">
//   //                 Fill in the details below to find the best AI talent for your
//   //                 project.
//   //               </Typography>
//   //             </Box>
//   //           </Paper>
//   //           <Paper elevation={0} sx={formPaperStyles}>
//   //             <Stack spacing={3}>
//   //               <Box>
//   //                 <SectionTitle>Basic Information</SectionTitle>
//   //                 <Grid container spacing={2}>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <TextField
//   //                       fullWidth
//   //                       label="Job Title*"
//   //                       value={jobData.title}
//   //                       onChange={(e) =>
//   //                         handleInputChange("title", e.target.value)
//   //                       }
//   //                     />
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6}>
//   //                     <TextField
//   //                       fullWidth
//   //                       label="Company Name"
//   //                       value={jobData.companyName}
//   //                       onChange={(e) =>
//   //                         handleInputChange("companyName", e.target.value)
//   //                       }
//   //                     />
//   //                   </Grid>
//   //                   <Grid item xs={12}>
//   //                     <TextField
//   //                       fullWidth
//   //                       label="Location*"
//   //                       value={jobData.location}
//   //                       onChange={(e) =>
//   //                         handleInputChange("location", e.target.value)
//   //                       }
//   //                     />
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6} md={4}>
//   //                     <FormControl fullWidth>
//   //                       <InputLabel id="job-type-label">Job Type*</InputLabel>
//   //                       <Select
//   //                         labelId="job-type-label"
//   //                         label="Job Type*"
//   //                         value={jobData.jobType}
//   //                         onChange={(e) =>
//   //                           handleInputChange("jobType", e.target.value)
//   //                         }
//   //                       >
//   //                         <MenuItem value="full-time">Full-time</MenuItem>
//   //                         <MenuItem value="part-time">Part-time</MenuItem>
//   //                         <MenuItem value="contract">Contract</MenuItem>
//   //                         <MenuItem value="freelance">Freelance</MenuItem>
//   //                       </Select>
//   //                     </FormControl>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6} md={4}>
//   //                     <FormControl fullWidth>
//   //                       <InputLabel id="experience-label">
//   //                         Experience Level*
//   //                       </InputLabel>
//   //                       <Select
//   //                         labelId="experience-label"
//   //                         label="Experience Level*"
//   //                         value={jobData.experience}
//   //                         onChange={(e) =>
//   //                           handleInputChange("experience", e.target.value)
//   //                         }
//   //                       >
//   //                         <MenuItem value="entry">
//   //                           Entry Level (0-2 years)
//   //                         </MenuItem>
//   //                         <MenuItem value="mid">Mid Level (3-5 years)</MenuItem>
//   //                         <MenuItem value="senior">
//   //                           Senior Level (5+ years)
//   //                         </MenuItem>
//   //                         <MenuItem value="lead">
//   //                           Lead/Principal (8+ years)
//   //                         </MenuItem>
//   //                       </Select>
//   //                     </FormControl>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6} md={4}>
//   //                     <TextField
//   //                       fullWidth
//   //                       label="Contact Email"
//   //                       value={jobData.contactEmail}
//   //                       onChange={(e) =>
//   //                         handleInputChange("contactEmail", e.target.value)
//   //                       }
//   //                     />
//   //                   </Grid>
//   //                 </Grid>
//   //               </Box>
//   //               <Divider />
//   //               <Box>
//   //                 <SectionTitle>Salary Information</SectionTitle>
//   //                 <Grid container spacing={2}>
//   //                   <Grid item xs={12} sm={4}>
//   //                     <FormControl fullWidth>
//   //                       <InputLabel id="currency-label">Currency</InputLabel>
//   //                       <Select
//   //                         labelId="currency-label"
//   //                         label="Currency"
//   //                         value={jobData.currency}
//   //                         onChange={(e) =>
//   //                           handleInputChange("currency", e.target.value)
//   //                         }
//   //                       >
//   //                         <MenuItem value="USD">USD ($)</MenuItem>
//   //                         <MenuItem value="EUR">EUR (€)</MenuItem>
//   //                         <MenuItem value="GBP">GBP (£)</MenuItem>
//   //                         <MenuItem value="AED">AED (د.إ)</MenuItem>
//   //                         <MenuItem value="SGD">SGD (S$)</MenuItem>
//   //                       </Select>
//   //                     </FormControl>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={4}>
//   //                     <TextField
//   //                       fullWidth
//   //                       type="number"
//   //                       label="Minimum Salary"
//   //                       value={jobData.salaryMin}
//   //                       onChange={(e) =>
//   //                         handleInputChange("salaryMin", e.target.value)
//   //                       }
//   //                     />
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={4}>
//   //                     <TextField
//   //                       fullWidth
//   //                       type="number"
//   //                       label="Maximum Salary"
//   //                       value={jobData.salaryMax}
//   //                       onChange={(e) =>
//   //                         handleInputChange("salaryMax", e.target.value)
//   //                       }
//   //                     />
//   //                   </Grid>
//   //                 </Grid>
//   //               </Box>
//   //               <Divider />
//   //               <Box>
//   //                 <SectionTitle>Job Description</SectionTitle>
//   //                 <TextField
//   //                   fullWidth
//   //                   multiline
//   //                   rows={5}
//   //                   label="Detailed Job Description*"
//   //                   value={jobData.description}
//   //                   onChange={(e) =>
//   //                     handleInputChange("description", e.target.value)
//   //                   }
//   //                 />
//   //               </Box>
//   //               <Grid container spacing={3}>
//   //                 <Grid item xs={12} md={4}>
//   //                   <SectionTitle>Requirements</SectionTitle>
//   //                   <Stack direction="row" spacing={1}>
//   //                     <TextField
//   //                       fullWidth
//   //                       label="Add Requirement"
//   //                       value={newRequirement}
//   //                       onChange={(e) => setNewRequirement(e.target.value)}
//   //                     />
//   //                     <Button
//   //                       variant="contained"
//   //                       onClick={() =>
//   //                         handleAddItem(
//   //                           "requirements",
//   //                           newRequirement,
//   //                           setNewRequirement
//   //                         )
//   //                       }
//   //                       sx={{ minWidth: 50 }}
//   //                     >
//   //                       <Add />
//   //                     </Button>
//   //                   </Stack>
//   //                   <Box
//   //                     sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 2 }}
//   //                   >
//   //                     {jobData.requirements.map((req, index) => (
//   //                       <Chip
//   //                         key={index}
//   //                         label={req}
//   //                         onDelete={() => handleRemoveItem("requirements", index)}
//   //                       />
//   //                     ))}
//   //                   </Box>
//   //                 </Grid>
//   //                 <Grid item xs={12} md={4}>
//   //                   <SectionTitle>Benefits</SectionTitle>
//   //                   <Stack direction="row" spacing={1}>
//   //                     <TextField
//   //                       fullWidth
//   //                       label="Add Benefit"
//   //                       value={newBenefit}
//   //                       onChange={(e) => setNewBenefit(e.target.value)}
//   //                     />
//   //                     <Button
//   //                       variant="contained"
//   //                       onClick={() =>
//   //                         handleAddItem("benefits", newBenefit, setNewBenefit)
//   //                       }
//   //                       sx={{ minWidth: 50 }}
//   //                     >
//   //                       <Add />
//   //                     </Button>
//   //                   </Stack>
//   //                   <Box
//   //                     sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 2 }}
//   //                   >
//   //                     {jobData.benefits.map((benefit, index) => (
//   //                       <Chip
//   //                         key={index}
//   //                         label={benefit}
//   //                         onDelete={() => handleRemoveItem("benefits", index)}
//   //                       />
//   //                     ))}
//   //                   </Box>
//   //                 </Grid>
//   //                 <Grid item xs={12} md={4}>
//   //                   <SectionTitle>Required Skills</SectionTitle>
//   //                   <Stack spacing={2}>
//   //                     <FormControl fullWidth>
//   //                       <InputLabel id="skill-select-label">
//   //                         Select from common skills...
//   //                       </InputLabel>
//   //                       <Select
//   //                         labelId="skill-select-label"
//   //                         label="Select from common skills..."
//   //                         value=""
//   //                         onChange={(e) => handleSkillAdd(e.target.value)}
//   //                         displayEmpty
//   //                       >
//   //                         {skillOptions.map((skill) => (
//   //                           <MenuItem key={skill} value={skill}>
//   //                             {skill}
//   //                           </MenuItem>
//   //                         ))}
//   //                       </Select>
//   //                     </FormControl>
//   //                     <Stack direction="row" spacing={1}>
//   //                       <TextField
//   //                         fullWidth
//   //                         label="Or add a custom skill"
//   //                         value={newSkill}
//   //                         onChange={(e) => setNewSkill(e.target.value)}
//   //                       />
//   //                       <Button
//   //                         variant="contained"
//   //                         onClick={() => {
//   //                           handleSkillAdd(newSkill);
//   //                           setNewSkill("");
//   //                         }}
//   //                         sx={{ minWidth: 50 }}
//   //                       >
//   //                         <Add />
//   //                       </Button>
//   //                     </Stack>
//   //                     <Box
//   //                       sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 1 }}
//   //                     >
//   //                       {jobData.skills.map((skill, index) => (
//   //                         <Chip
//   //                           key={index}
//   //                           label={skill}
//   //                           onDelete={() => handleRemoveItem("skills", index)}
//   //                         />
//   //                       ))}
//   //                     </Box>
//   //                   </Stack>
//   //                 </Grid>
//   //               </Grid>
//   //               <Divider />
//   //               <Box>
//   //                 <SectionTitle>Additional Information</SectionTitle>
//   //                 <Grid container spacing={2} alignItems="center">
//   //                   <Grid item xs={12} sm={6} md={4}>
//   //                     <LocalizationProvider dateAdapter={AdapterDateFns}>
//   //                       <DatePicker
//   //                         label="Application Deadline"
//   //                         value={jobData.applicationDeadline}
//   //                         onChange={(newValue) =>
//   //                           handleInputChange("applicationDeadline", newValue)
//   //                         }
//   //                         slotProps={{ textField: { fullWidth: true } }}
//   //                       />
//   //                     </LocalizationProvider>
//   //                   </Grid>
//   //                   <Grid item xs={12} sm={6} md={8}>
//   //                     <Stack direction="row" spacing={2} flexWrap="wrap">
//   //                       <Button
//   //                         variant={
//   //                           jobData.visaSponsorship ? "contained" : "outlined"
//   //                         }
//   //                         color="primary"
//   //                         onClick={() =>
//   //                           handleInputChange(
//   //                             "visaSponsorship",
//   //                             !jobData.visaSponsorship
//   //                           )
//   //                         }
//   //                       >
//   //                         Visa Sponsorship
//   //                       </Button>
//   //                       <Button
//   //                         variant={jobData.remoteWork ? "contained" : "outlined"}
//   //                         color="primary"
//   //                         onClick={() =>
//   //                           handleInputChange("remoteWork", !jobData.remoteWork)
//   //                         }
//   //                       >
//   //                         Remote Work
//   //                       </Button>
//   //                     </Stack>
//   //                   </Grid>
//   //                 </Grid>
//   //               </Box>
//   //               <Stack
//   //                 direction={{ xs: "column-reverse", sm: "row" }}
//   //                 spacing={2}
//   //                 justifyContent="space-between"
//   //                 alignItems="center"
//   //                 sx={{ pt: 2 }}
//   //               >
//   //                 <Typography
//   //                   variant="body2"
//   //                   color="text.secondary"
//   //                   sx={{ display: { xs: "none", sm: "block" } }}
//   //                 >
//   //                   Please ensure all information is accurate.
//   //                 </Typography>
//   //                 <Stack
//   //                   direction={{ xs: "column", sm: "row" }}
//   //                   spacing={2}
//   //                   sx={{ width: { xs: "100%", sm: "auto" } }}
//   //                 >
//   //                   <Button
//   //                     variant="outlined"
//   //                     color="secondary"
//   //                     startIcon={<Visibility />}
//   //                     onClick={() => setIsPreviewing(true)}
//   //                   >
//   //                     Preview
//   //                   </Button>
//   //                   <Button
//   //                     variant="outlined"
//   //                     color="primary"
//   //                     startIcon={<Save />}
//   //                     disabled={loading}
//   //                     onClick={() => handleSubmit("DRAFT")}
//   //                   >
//   //                     Save as Draft
//   //                   </Button>
//   //                   <Button
//   //                     variant="contained"
//   //                     color="primary"
//   //                     startIcon={
//   //                       loading ? (
//   //                         <CircularProgress size={20} color="inherit" />
//   //                       ) : (
//   //                         <Save />
//   //                       )
//   //                     }
//   //                     onClick={() => handleSubmit("PUBLISHED")}
//   //                     disabled={loading}
//   //                   >
//   //                     Post Job
//   //                   </Button>
//   //                 </Stack>
//   //               </Stack>
//   //             </Stack>
//   //           </Paper>
//   //         </Stack>
//   //       </Container>
//   //     </Layout>
//   //   );
//   // };

//   // export default JobPosting;

//   "use client";

// import { useState, useEffect } from "react";
// import apiClient from "../../context/apiClient";
// import {
//   Grid,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   Select,
//   MenuItem,
//   Chip,
//   Divider,
//   Paper,
//   CircularProgress,
//   Container,
//   Stack,
//   InputLabel,
//   Skeleton,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import { Add, Edit, Save, Visibility } from "@mui/icons-material";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import Layout from "../common/Layout";
// import { useNotification } from "../../context/NotificationContext";

// const JobPosting = () => {
//   const theme = useTheme();
//   const { showNotification } = useNotification();

//   const initialJobData = {
//     title: "",
//     companyName: "",
//     contactEmail: "",
//     location: "",
//     jobType: "",
//     experience: "",
//     salaryMin: "",
//     salaryMax: "",
//     currency: "USD",
//     description: "",
//     requirements: [],
//     benefits: [],
//     skills: [],
//     applicationDeadline: null,
//     visaSponsorship: false,
//     remoteWork: false,
//   };

//   const [loading, setLoading] = useState(false);
//   const [isPageLoading, setIsPageLoading] = useState(true);
//   const [isPreviewing, setIsPreviewing] = useState(false);
//   const [jobData, setJobData] = useState(initialJobData);
//   const [newRequirement, setNewRequirement] = useState("");
//   const [newBenefit, setNewBenefit] = useState("");
//   const [newSkill, setNewSkill] = useState("");

//   useEffect(() => {
//     const timer = setTimeout(() => setIsPageLoading(false), 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   const skillOptions = [
//     "Python", "Machine Learning", "Deep Learning", "TensorFlow", "PyTorch", "NLP", "Computer Vision",
//     "Data Science", "AWS", "Azure", "GCP", "Kubernetes", "Docker", "React", "Node.js", "SQL", "NoSQL",
//   ];
//   const jobTypeDisplayMapping = {
//     "full-time": "Full-time", "part-time": "Part-time", contract: "Contract", freelance: "Freelance",
//   };
//   const experienceDisplayMapping = {
//     entry: "Entry Level (0-2 years)", mid: "Mid Level (3-5 years)",
//     senior: "Senior Level (5+ years)", lead: "Lead/Principal (8+ years)",
//   };

//   const handleInputChange = (field, value) => setJobData((prev) => ({ ...prev, [field]: value }));

//   const handleAddItem = (field, value, setter) => {
//     if (value.trim()) {
//       setJobData((prev) => ({ ...prev, [field]: [...prev[field], value.trim()] }));
//       setter("");
//     }
//   };

//   const handleSkillAdd = (skill) => {
//     if (skill && !jobData.skills.includes(skill)) {
//       setJobData((prev) => ({ ...prev, skills: [...prev.skills, skill] }));
//     }
//   };

//   const handleRemoveItem = (field, index) =>
//     setJobData((prev) => ({ ...prev, [field]: prev[field].filter((_, i) => i !== index) }));

//   const handleSubmit = async (status) => {
//     if (!jobData.title || !jobData.location || !jobData.description) {
//       showNotification("Please fill in all required fields: Title, Location, and Description", "error");
//       return;
//     }
//     if (!jobData.jobType || !jobData.experience) {
//       showNotification("Please select a Job Type and Experience Level.", "error");
//       return;
//     }
//     setLoading(true);
//     const deadline = jobData.applicationDeadline ? new Date(jobData.applicationDeadline).toISOString().split("T")[0] : null;
//     const payload = {
//       title: jobData.title,
//       description: jobData.description,
//       responsibilities: jobData.description,
//       requirements: jobData.requirements,
//       location: jobData.location,
//       job_type: jobTypeDisplayMapping[jobData.jobType],
//       experience_level: { entry: "Entry-level", mid: "Mid-level", senior: "Senior-level", lead: "Lead/Principal" }[jobData.experience],
//       salary_currency: jobData.currency,
//       salary_min: jobData.salaryMin ? parseFloat(jobData.salaryMin) : null,
//       salary_max: jobData.salaryMax ? parseFloat(jobData.salaryMax) : null,
//       benefits: jobData.benefits,
//       required_skills: jobData.skills,
//       visa_sponsorship: jobData.visaSponsorship,
//       remote_work: jobData.remoteWork,
//       status: status,
//       application_deadline: deadline,
//     };

//     try {
//       await apiClient.post("/job-postings/", payload);
//       showNotification(status === "DRAFT" ? "Job saved as draft!" : "Job posted successfully!", "success");
//       if (status === "PUBLISHED") setIsPreviewing(false);
//       setJobData(initialJobData);
//       setNewRequirement("");
//       setNewBenefit("");
//       setNewSkill("");
//     } catch (error) {
//       console.error("Failed to post job:", error);
//       let errorMessage = "Failed to post job.";
//       if (error.response?.data) {
//         const errors = error.response.data;
//         const firstErrorKey = Object.keys(errors)[0];
//         errorMessage = `${firstErrorKey}: ${Array.isArray(errors[firstErrorKey]) ? errors[firstErrorKey][0] : errors[firstErrorKey]}`;
//       }
//       showNotification(errorMessage, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const SectionTitle = ({ children }) => (
//     <Typography variant="h6" fontWeight="bold" sx={{ color: "primary.main", mb: 2 }}>
//       {children}
//     </Typography>
//   );

//   const formPaperStyles = {
//     p: { xs: 2, md: 4 },
//     borderRadius: "12px",
//     backgroundColor: theme.palette.mint.main,
//     boxShadow: theme.shadows[1],
//   };

//   if (isPageLoading) {
//     return (
//       <Layout title="Post New Job">
//         <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//           <Stack spacing={4}>
//             <Skeleton variant="rectangular" height={100} sx={{ borderRadius: "12px" }} />
//             <Skeleton variant="rectangular" height={600} sx={{ borderRadius: "12px" }} />
//           </Stack>
//         </Container>
//       </Layout>
//     );
//   }

//   if (isPreviewing) {
//      return (
//         <Layout title="Preview Job Posting">
//           <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//             <Paper elevation={0} sx={formPaperStyles}>
//               <Stack spacing={4}>
//                 <Box>
//                   <Typography variant="h4" component="h1" fontWeight="bold">
//                     {jobData.title || "Job Title"}
//                   </Typography>
//                   <Typography variant="h6" color="text.secondary">
//                     {jobData.companyName || "Company Name"} - {jobData.location || "Location"}
//                   </Typography>
//                 </Box>
//                 <Divider />
//                 <Box>
//                     <SectionTitle>Job Description</SectionTitle>
//                     <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
//                         {jobData.description}
//                     </Typography>
//                 </Box>
//                 <Grid container spacing={4}>
//                   <Grid item xs={12} md={6}>
//                     <SectionTitle>Requirements</SectionTitle>
//                     <Stack spacing={1}>
//                       {jobData.requirements.length > 0 ? (
//                         jobData.requirements.map((item, index) => (
//                           <Typography key={index} variant="body1"> • {item} </Typography>
//                         ))
//                       ) : ( <Typography variant="body2" color="text.secondary">No requirements listed.</Typography> )}
//                     </Stack>
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <SectionTitle>Benefits</SectionTitle>
//                     <Stack spacing={1}>
//                     {jobData.benefits.length > 0 ? (
//                       jobData.benefits.map((item, index) => (
//                         <Typography key={index} variant="body1"> • {item} </Typography>
//                       ))
//                     ) : ( <Typography variant="body2" color="text.secondary">No benefits listed.</Typography> )}
//                     </Stack>
//                   </Grid>
//                 </Grid>
//                 <Box>
//                   <SectionTitle>Required Skills</SectionTitle>
//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                   {jobData.skills.length > 0 ? (
//                     jobData.skills.map((skill, index) => ( <Chip key={index} label={skill} /> ))
//                   ) : ( <Typography variant="body2" color="text.secondary">No skills listed.</Typography> )}
//                   </Box>
//                 </Box>
//                 <Divider />
//                 <Box>
//                   <SectionTitle>Additional Information</SectionTitle>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <Typography fontWeight="bold">Job Type:</Typography>
//                       <Typography>{jobTypeDisplayMapping[jobData.jobType] || "Not Specified"}</Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography fontWeight="bold">Experience Level:</Typography>
//                       <Typography>{experienceDisplayMapping[jobData.experience] || "Not Specified"}</Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography fontWeight="bold">Salary:</Typography>
//                       <Typography>
//                         {jobData.salaryMin && jobData.salaryMax ? `${jobData.salaryMin} - ${jobData.salaryMax} ${jobData.currency}` : "Not Disclosed"}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Typography fontWeight="bold">Application Deadline:</Typography>
//                       <Typography>
//                         {jobData.applicationDeadline ? new Date(jobData.applicationDeadline).toLocaleDateString() : "N/A"}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}> <Typography><b>Visa Sponsorship:</b> {jobData.visaSponsorship ? "Yes" : "No"}</Typography> </Grid>
//                     <Grid item xs={12} sm={6}> <Typography><b>Remote Work:</b> {jobData.remoteWork ? "Yes" : "No"}</Typography> </Grid>
//                   </Grid>
//                 </Box>
//                 <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="flex-end" sx={{ pt: 3 }}>
//                   <Button variant="outlined" color="primary" startIcon={<Edit />} onClick={() => setIsPreviewing(false)}> Back to Edit </Button>
//                   <Button variant="outlined" color="secondary" startIcon={<Save />} disabled={loading} onClick={() => handleSubmit("DRAFT")}> Save as Draft </Button>
//                   <Button variant="contained" color="primary" startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Save />} disabled={loading} onClick={() => handleSubmit("PUBLISHED")}> Publish Job </Button>
//                 </Stack>
//               </Stack>
//             </Paper>
//           </Container>
//         </Layout>
//       );
//   }

//   return (
//     <Layout title="Post New Job">
//       <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//         <Stack spacing={4}>
//           <Paper elevation={0} sx={formPaperStyles}>
//             <Typography variant="h4" component="h1" fontWeight="bold" color="primary.main"> Create a New Job Posting </Typography>
//             <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}> Fill in the details below to find the best AI talent for your project. </Typography>
//           </Paper>
//           <Paper elevation={0} sx={formPaperStyles}>
//             <Stack spacing={4}>
//               <Box>
//                 <SectionTitle>Basic Information</SectionTitle>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} sm={6}> <TextField fullWidth label="Job Title" value={jobData.title} onChange={(e) => handleInputChange("title", e.target.value)} /> </Grid>
//                   <Grid item xs={12} sm={6}> <TextField fullWidth label="Company Name" value={jobData.companyName} onChange={(e) => handleInputChange("companyName", e.target.value)} /> </Grid>
//                   <Grid item xs={12}> <TextField fullWidth label="Location" value={jobData.location} onChange={(e) => handleInputChange("location", e.target.value)} /> </Grid>

//                   {/* --- DEFINITIVE FIX APPLIED HERE --- */}
//                   <Grid item xs={12}>
//                     <FormControl fullWidth sx={{width:"150px"}}>
//                       <InputLabel id="job-type-select-label" >Job Type</InputLabel>
//                       <Select
//                         labelId="job-type-select-label"
//                         id="job-type-select"
//                         value={jobData.jobType}
//                         label="Job Type"
//                         onChange={(e) => handleInputChange("jobType", e.target.value)}
//                       >
//                         <MenuItem value="" disabled> <em>Select Job Type...</em> </MenuItem>
//                         <MenuItem value="full-time">Full-time</MenuItem>
//                         <MenuItem value="part-time">Part-time</MenuItem>
//                         <MenuItem value="contract">Contract</MenuItem>
//                         <MenuItem value="freelance">Freelance</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <FormControl fullWidth sx={{width:"200px"}}>
//                       <InputLabel id="experience-level-select-label">Experience Level</InputLabel>
//                       <Select
//                         labelId="experience-level-select-label"
//                         id="experience-level-select"
//                         value={jobData.experience}
//                         label="Experience Level"
//                         onChange={(e) => handleInputChange("experience", e.target.value)}
//                       >
//                         <MenuItem value="" disabled> <em>Select Experience Level...</em> </MenuItem>
//                         <MenuItem value="entry">Entry Level (0-2 years)</MenuItem>
//                         <MenuItem value="mid">Mid Level (3-5 years)</MenuItem>
//                         <MenuItem value="senior">Senior Level (5+ years)</MenuItem>
//                         <MenuItem value="lead">Lead/Principal (8+ years)</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   {/* --- END OF FIX --- */}

//                   <Grid item xs={12}> <TextField fullWidth label="Contact Email" value={jobData.contactEmail} onChange={(e) => handleInputChange("contactEmail", e.target.value)} /> </Grid>
//                 </Grid>
//               </Box>

//               <Divider />

//               <Box>
//                 <SectionTitle>Salary Information</SectionTitle>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} sm={4}>
//                     <FormControl fullWidth>
//                       <InputLabel id="currency-label">Currency</InputLabel>
//                       <Select labelId="currency-label" label="Currency" value={jobData.currency} onChange={(e) => handleInputChange("currency", e.target.value)}>
//                         <MenuItem value="USD">USD ($)</MenuItem>
//                         <MenuItem value="EUR">EUR (€)</MenuItem>
//                         <MenuItem value="GBP">GBP (£)</MenuItem>
//                         <MenuItem value="AED">AED (د.إ)</MenuItem>
//                         <MenuItem value="SGD">SGD (S$)</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={4}> <TextField fullWidth type="number" label="Minimum Salary" value={jobData.salaryMin} onChange={(e) => handleInputChange("salaryMin", e.target.value)} /> </Grid>
//                   <Grid item xs={12} sm={4}> <TextField fullWidth type="number" label="Maximum Salary" value={jobData.salaryMax} onChange={(e) => handleInputChange("salaryMax", e.target.value)} /> </Grid>
//                 </Grid>
//               </Box>

//               <Divider />

//               <Box>
//                 <SectionTitle>Job Description</SectionTitle>
//                 <TextField fullWidth multiline rows={6} label="Detailed Job Description*" value={jobData.description} onChange={(e) => handleInputChange("description", e.target.value)} />
//               </Box>

//               <Grid container spacing={4}>
//                 <Grid item xs={12} md={6}>
//                   <SectionTitle>Requirements</SectionTitle>
//                   <Stack spacing={2}>
//                     <Stack direction="row" spacing={1} alignItems="center">
//                       <TextField fullWidth label="Add Requirement" value={newRequirement} onChange={(e) => setNewRequirement(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleAddItem("requirements", newRequirement, setNewRequirement)} />
//                       <Button variant="contained" onClick={() => handleAddItem("requirements", newRequirement, setNewRequirement)} sx={{ height: 'fit-content', padding: '10px' }}> <Add /> </Button>
//                     </Stack>
//                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                       {jobData.requirements.map((req, index) => ( <Chip key={index} label={req} onDelete={() => handleRemoveItem("requirements", index)} /> ))}
//                     </Box>
//                   </Stack>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <SectionTitle>Benefits</SectionTitle>
//                   <Stack spacing={2}>
//                     <Stack direction="row" spacing={1} alignItems="center">
//                       <TextField fullWidth label="Add Benefit" value={newBenefit} onChange={(e) => setNewBenefit(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleAddItem("benefits", newBenefit, setNewBenefit)} />
//                       <Button variant="contained" onClick={() => handleAddItem("benefits", newBenefit, setNewBenefit)} sx={{ height: 'fit-content', padding: '10px' }}> <Add /> </Button>
//                     </Stack>
//                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                       {jobData.benefits.map((benefit, index) => ( <Chip key={index} label={benefit} onDelete={() => handleRemoveItem("benefits", index)} /> ))}
//                     </Box>
//                   </Stack>
//                 </Grid>
//               </Grid>

//               <Box>
//                 <SectionTitle>Required Skills</SectionTitle>
//                 <Stack spacing={2}>
//                   <FormControl fullWidth>
//                     <InputLabel id="skill-select-label"> Select from common skills... </InputLabel>
//                     <Select labelId="skill-select-label" label="Select from common skills..." value="" onChange={(e) => handleSkillAdd(e.target.value)} >
//                       {skillOptions.map((skill) => ( <MenuItem key={skill} value={skill}> {skill} </MenuItem> ))}
//                     </Select>
//                   </FormControl>
//                   <Stack direction="row" spacing={1} alignItems="center">
//                     <TextField fullWidth label="Or add a custom skill" value={newSkill} onChange={(e) => setNewSkill(e.target.value)} onKeyPress={(e) => { if (e.key === 'Enter') { handleSkillAdd(newSkill); setNewSkill(""); } }} />
//                     <Button variant="contained" onClick={() => { handleSkillAdd(newSkill); setNewSkill(""); }} sx={{ height: 'fit-content', padding: '10px' }}> <Add /> </Button>
//                   </Stack>
//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 1 }}>
//                     {jobData.skills.map((skill, index) => ( <Chip key={index} label={skill} onDelete={() => handleRemoveItem("skills", index)} /> ))}
//                   </Box>
//                 </Stack>
//               </Box>

//               <Divider />

//               <Box>
//                 <SectionTitle>Additional Information</SectionTitle>
//                 <Grid container spacing={3} alignItems="center">
//                   <Grid item xs={12} md={4}>
//                     <LocalizationProvider dateAdapter={AdapterDateFns}>
//                       <DatePicker label="Application Deadline" value={jobData.applicationDeadline} onChange={(newValue) => handleInputChange("applicationDeadline", newValue)} slotProps={{ textField: { fullWidth: true } }} />
//                     </LocalizationProvider>
//                   </Grid>
//                   <Grid item xs={12} md={8}>
//                     <Stack direction="row" spacing={2} flexWrap="wrap">
//                       <Button variant={jobData.visaSponsorship ? "contained" : "outlined"} onClick={() => handleInputChange("visaSponsorship", !jobData.visaSponsorship)}> Visa Sponsorship </Button>
//                       <Button variant={jobData.remoteWork ? "contained" : "outlined"} onClick={() => handleInputChange("remoteWork", !jobData.remoteWork)}> Remote Work </Button>
//                     </Stack>
//                   </Grid>
//                 </Grid>
//               </Box>

//               <Stack direction={{ xs: "column-reverse", sm: "row" }} spacing={2} justifyContent="flex-end" alignItems="center" sx={{ pt: 3 }} >
//                 <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ width: { xs: "100%", sm: "auto" } }}>
//                   <Button variant="outlined" color="secondary" startIcon={<Visibility />} onClick={() => setIsPreviewing(true)}> Preview </Button>
//                   <Button variant="outlined" color="primary" startIcon={<Save />} disabled={loading} onClick={() => handleSubmit("DRAFT")}> Save as Draft </Button>
//                   <Button variant="contained" color="primary" startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Save />} onClick={() => handleSubmit("PUBLISHED")} disabled={loading}> Post Job </Button>
//                 </Stack>
//               </Stack>
//             </Stack>
//           </Paper>
//         </Stack>
//       </Container>
//     </Layout>
//   );
// };

// export default JobPosting;

// "use client";

// import { useState, useEffect, useCallback } from "react";
// import apiClient from "../../context/apiClient";

// import {
//   Grid,
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   Select,
//   MenuItem,
//   Chip,
//   Divider,
//   Paper,
//   CircularProgress,
//   Container,
//   Stack,
//   InputLabel,
//   Skeleton,
//   Autocomplete,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import { Add, Edit, Save, Visibility } from "@mui/icons-material";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import Layout from "../common/Layout";
// import { useNotification } from "../../context/NotificationContext";
// import { debounce } from "lodash";

// const JobPosting = () => {
//   const theme = useTheme();
//   const { showNotification } = useNotification();

//   const initialJobData = {
//     title: "",
//     companyName: "",
//     contactEmail: "",
//     location: "",
//     jobType: "",
//     experience: "",
//     salaryMin: "",
//     salaryMax: "",
//     currency: "USD",
//     description: "",
//     requirements: [],
//     benefits: [],
//     skills: [],
//     applicationDeadline: null,
//     visaSponsorship: false,
//     remoteWork: false,
//   };

//   const [loading, setLoading] = useState(false);
//   const [isPageLoading, setIsPageLoading] = useState(true);
//   const [isPreviewing, setIsPreviewing] = useState(false);
//   const [jobData, setJobData] = useState(initialJobData);
//   const [newRequirement, setNewRequirement] = useState("");
//   const [newBenefit, setNewBenefit] = useState("");
//   const [newSkill, setNewSkill] = useState("");

//   // --- Location autocomplete logic ---
//   const [locationOptions, setLocationOptions] = useState([]);
//   const [isLocationLoading, setIsLocationLoading] = useState(false);
//   const GEONAMES_USERNAME = "jobhustle";

//   const fetchLocations = async (query) => {
//     if (query.length < 2) {
//       setLocationOptions([]);
//       return;
//     }
//     setIsLocationLoading(true);
//     try {
//       const response = await fetch(
//         `http://api.geonames.org/searchJSON?q=${query}&maxRows=5&featureClass=P&username=${GEONAMES_USERNAME}`
//       );
//       const data = await response.json();
//       if (data.geonames) {
//         const formattedOptions = data.geonames.map(
//           (item) => `${item.name}, ${item.countryName}`
//         );
//         setLocationOptions(formattedOptions);
//       }
//     } catch (error) {
//       console.error("Failed to fetch locations:", error);
//     } finally {
//       setIsLocationLoading(false);
//     }
//   };

//   const debouncedFetchLocations = useCallback(
//     debounce(fetchLocations, 300),
//     []
//   );
//   // --- End of location logic ---

//   // --- CURRENCY API INTEGRATION START ---
//   const [currencies, setCurrencies] = useState([]);
//   const [isCurrenciesLoading, setIsCurrenciesLoading] = useState(true);

//   useEffect(() => {
//     const fetchCurrencies = async () => {
//       try {
//         const response = await fetch("https://api.frankfurter.app/currencies");
//         const data = await response.json();
//         const formattedCurrencies = Object.entries(data).map(
//           ([code, name]) => ({
//             code,
//             name,
//           })
//         );
//         setCurrencies(formattedCurrencies);
//       } catch (error) {
//         console.error("Failed to fetch currencies:", error);
//         // Fallback to a basic list in case of an API error
//         setCurrencies([
//           { code: "USD", name: "United States Dollar" },
//           { code: "EUR", name: "Euro" },
//           { code: "GBP", name: "British Pound Sterling" },
//           { code: "AED", name: "United Arab Emirates Dirham" },
//           { code: "SGD", name: "Singapore Dollar" },
//         ]);
//       } finally {
//         setIsCurrenciesLoading(false);
//       }
//     };

//     fetchCurrencies();
//   }, []); // Empty dependency array means this runs once on mount
//   // --- CURRENCY API INTEGRATION END ---

//   useEffect(() => {
//     const timer = setTimeout(() => setIsPageLoading(false), 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   const skillOptions = [
//     "Python",
//     "Machine Learning",
//     "Deep Learning",
//     "TensorFlow",
//     "PyTorch",
//     "NLP",
//     "Computer Vision",
//     "Data Science",
//     "AWS",
//     "Azure",
//     "GCP",
//     "Kubernetes",
//     "Docker",
//     "React",
//     "Node.js",
//     "SQL",
//     "NoSQL",
//   ];

//   const jobTypeDisplayMapping = {
//     "full-time": "Full-time",
//     "part-time": "Part-time",
//     contract: "Contract",
//     freelance: "Freelance",
//   };

//   const experienceDisplayMapping = {
//     entry: "Entry Level (0-2 years)",
//     mid: "Mid Level (3-5 years)",
//     senior: "Senior Level (5+ years)",
//     lead: "Lead/Principal (8+ years)",
//   };

//   const handleInputChange = (field, value) =>
//     setJobData((prev) => ({ ...prev, [field]: value }));

//   const handleAddItem = (field, value, setter) => {
//     if (value.trim()) {
//       setJobData((prev) => ({
//         ...prev,
//         [field]: [...prev[field], value.trim()],
//       }));
//       setter("");
//     }
//   };

//   const handleSkillAdd = (skill) => {
//     if (skill && !jobData.skills.includes(skill)) {
//       setJobData((prev) => ({ ...prev, skills: [...prev.skills, skill] }));
//     }
//   };

//   const handleRemoveItem = (field, index) =>
//     setJobData((prev) => ({
//       ...prev,
//       [field]: prev[field].filter((_, i) => i !== index),
//     }));

//   const handleSubmit = async (status) => {
//     if (!jobData.title || !jobData.location || !jobData.description) {
//       showNotification(
//         "Please fill in all required fields: Title, Location, and Description",
//         "error"
//       );
//       return;
//     }
//     if (!jobData.jobType || !jobData.experience) {
//       showNotification(
//         "Please select a Job Type and Experience Level.",
//         "error"
//       );
//       return;
//     }

//     setLoading(true);
//     const deadline = jobData.applicationDeadline
//       ? new Date(jobData.applicationDeadline).toISOString().split("T")[0]
//       : null;

//     const payload = {
//       title: jobData.title,
//       description: jobData.description,
//       responsibilities: jobData.description,
//       requirements: jobData.requirements,
//       location: jobData.location,
//       job_type: jobTypeDisplayMapping[jobData.jobType],
//       experience_level: {
//         entry: "Entry-level",
//         mid: "Mid-level",
//         senior: "Senior-level",
//         lead: "Lead/Principal",
//       }[jobData.experience],
//       salary_currency: jobData.currency,
//       salary_min: jobData.salaryMin ? parseFloat(jobData.salaryMin) : null,
//       salary_max: jobData.salaryMax ? parseFloat(jobData.salaryMax) : null,
//       benefits: jobData.benefits,
//       required_skills: jobData.skills,
//       visa_sponsorship: jobData.visaSponsorship,
//       remote_work: jobData.remoteWork,
//       status: status,
//       application_deadline: deadline,
//     };

//     try {
//       await apiClient.post("/job-postings/", payload);
//       showNotification(
//         status === "DRAFT" ? "Job saved as draft!" : "Job posted successfully!",
//         "success"
//       );
//       if (status === "PUBLISHED") setIsPreviewing(false);
//       setJobData(initialJobData);
//       setNewRequirement("");
//       setNewBenefit("");
//       setNewSkill("");
//     } catch (error) {
//       console.error("Failed to post job:", error);
//       let errorMessage = "Failed to post job.";
//       if (error.response?.data) {
//         const errors = error.response.data;
//         const firstErrorKey = Object.keys(errors)[0];
//         errorMessage = `${firstErrorKey}: ${
//           Array.isArray(errors[firstErrorKey])
//             ? errors[firstErrorKey][0]
//             : errors[firstErrorKey]
//         }`;
//       }
//       showNotification(errorMessage, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const SectionTitle = ({ children }) => (
//     <Typography
//       variant="h6"
//       fontWeight="bold"
//       sx={{ color: "primary.main", mb: 2 }}
//     >
//       {children}
//     </Typography>
//   );

//   const formPaperStyles = {
//     p: { xs: 2, md: 4 },
//     borderRadius: "12px",
//     backgroundColor: theme.palette.mint.main,
//     boxShadow: theme.shadows[1],
//   };

//   if (isPageLoading) {
//     return (
//       <Layout title="Post New Job">
//         <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//           <Stack spacing={4}>
//             <Skeleton
//               variant="rectangular"
//               height={100}
//               sx={{ borderRadius: "12px" }}
//             />
//             <Skeleton
//               variant="rectangular"
//               height={600}
//               sx={{ borderRadius: "12px" }}
//             />
//           </Stack>
//         </Container>
//       </Layout>
//     );
//   }

//   if (isPreviewing) {
//     return (
//       <Layout title="Preview Job Posting">
//         <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//           <Paper elevation={0} sx={formPaperStyles}>
//             <Stack spacing={4}>
//               <Box>
//                 <Typography variant="h4" component="h1" fontWeight="bold">
//                   {jobData.title || "Job Title"}
//                 </Typography>
//                 <Typography variant="h6" color="text.secondary">
//                   {jobData.companyName || "Company Name"} -{" "}
//                   {jobData.location || "Location"}
//                 </Typography>
//               </Box>
//               <Divider />
//               <Box>
//                 <SectionTitle>Job Description</SectionTitle>
//                 <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
//                   {jobData.description}
//                 </Typography>
//               </Box>
//               <Grid container spacing={4}>
//                 <Grid item xs={12} md={6}>
//                   <SectionTitle>Requirements</SectionTitle>
//                   <Stack spacing={1}>
//                     {jobData.requirements.length > 0 ? (
//                       jobData.requirements.map((item, index) => (
//                         <Typography key={index} variant="body1">
//                           {" "}
//                           • {item}{" "}
//                         </Typography>
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No requirements listed.
//                       </Typography>
//                     )}
//                   </Stack>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <SectionTitle>Benefits</SectionTitle>
//                   <Stack spacing={1}>
//                     {jobData.benefits.length > 0 ? (
//                       jobData.benefits.map((item, index) => (
//                         <Typography key={index} variant="body1">
//                           {" "}
//                           • {item}{" "}
//                         </Typography>
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No benefits listed.
//                       </Typography>
//                     )}
//                   </Stack>
//                 </Grid>
//               </Grid>
//               <Box>
//                 <SectionTitle>Required Skills</SectionTitle>
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                   {jobData.skills.length > 0 ? (
//                     jobData.skills.map((skill, index) => (
//                       <Chip key={index} label={skill} />
//                     ))
//                   ) : (
//                     <Typography variant="body2" color="text.secondary">
//                       No skills listed.
//                     </Typography>
//                   )}
//                 </Box>
//               </Box>
//               <Divider />
//               <Box>
//                 <SectionTitle>Additional Information</SectionTitle>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <Typography fontWeight="bold">Job Type:</Typography>
//                     <Typography>
//                       {jobTypeDisplayMapping[jobData.jobType] ||
//                         "Not Specified"}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography fontWeight="bold">Experience Level:</Typography>
//                     <Typography>
//                       {experienceDisplayMapping[jobData.experience] ||
//                         "Not Specified"}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography fontWeight="bold">Salary:</Typography>
//                     <Typography>
//                       {jobData.salaryMin && jobData.salaryMax
//                         ? `${jobData.salaryMin} - ${jobData.salaryMax} ${jobData.currency}`
//                         : "Not Disclosed"}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography fontWeight="bold">
//                       Application Deadline:
//                     </Typography>
//                     <Typography>
//                       {jobData.applicationDeadline
//                         ? new Date(
//                             jobData.applicationDeadline
//                           ).toLocaleDateString()
//                         : "N/A"}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography>
//                       <b>Visa Sponsorship:</b>{" "}
//                       {jobData.visaSponsorship ? "Yes" : "No"}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography>
//                       <b>Remote Work:</b> {jobData.remoteWork ? "Yes" : "No"}
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </Box>
//               <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={2}
//                 justifyContent="flex-end"
//                 sx={{ pt: 3 }}
//               >
//                 <Button
//                   variant="outlined"
//                   color="primary"
//                   startIcon={<Edit />}
//                   onClick={() => setIsPreviewing(false)}
//                 >
//                   {" "}
//                   Back to Edit{" "}
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   color="secondary"
//                   startIcon={<Save />}
//                   disabled={loading}
//                   onClick={() => handleSubmit("DRAFT")}
//                 >
//                   {" "}
//                   Save as Draft{" "}
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   startIcon={
//                     loading ? (
//                       <CircularProgress size={20} color="inherit" />
//                     ) : (
//                       <Save />
//                     )
//                   }
//                   disabled={loading}
//                   onClick={() => handleSubmit("PUBLISHED")}
//                 >
//                   {" "}
//                   Publish Job{" "}
//                 </Button>
//               </Stack>
//             </Stack>
//           </Paper>
//         </Container>
//       </Layout>
//     );
//   }

//   return (
//     <Layout title="Post New Job">
//       <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
//         <Stack spacing={4}>
//           <Paper elevation={0} sx={formPaperStyles}>
//             <Typography
//               variant="h4"
//               component="h1"
//               fontWeight="bold"
//               color="primary.main"
//             >
//               Create a New Job Posting
//             </Typography>
//             <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
//               Fill in the details below to find the best AI talent for your
//               project.
//             </Typography>
//           </Paper>

//           <Paper elevation={0} sx={formPaperStyles}>
//             <Stack spacing={4}>
//               <Box>
//                 <SectionTitle>Basic Information</SectionTitle>
//                 <Box
//                   sx={{
//                     display: "grid",
//                     gridTemplateColumns: {
//                       xs: "1fr",
//                       md: "repeat(3, 1fr)",
//                     },
//                     gap: 3,
//                   }}
//                 >
//                   <TextField
//                     fullWidth
//                     label="Job Title"
//                     value={jobData.title}
//                     onChange={(e) => handleInputChange("title", e.target.value)}
//                   />
//                   <TextField
//                     fullWidth
//                     label="Company Name"
//                     value={jobData.companyName}
//                     onChange={(e) =>
//                       handleInputChange("companyName", e.target.value)
//                     }
//                   />
//                   <Autocomplete
//                     fullWidth
//                     options={locationOptions}
//                     loading={isLocationLoading}
//                     freeSolo
//                     value={jobData.location}
//                     onInputChange={(event, newInputValue) => {
//                       handleInputChange("location", newInputValue);
//                       debouncedFetchLocations(newInputValue);
//                     }}
//                     onChange={(event, newValue) => {
//                       handleInputChange("location", newValue || "");
//                     }}
//                     renderInput={(params) => (
//                       <TextField {...params} label="Location" />
//                     )}
//                   />
//                   <FormControl fullWidth>
//                     <InputLabel id="job-type-select-label">Job Type</InputLabel>
//                     <Select
//                       labelId="job-type-select-label"
//                       value={jobData.jobType}
//                       label="Job Type"
//                       onChange={(e) =>
//                         handleInputChange("jobType", e.target.value)
//                       }
//                     >
//                       <MenuItem value="" disabled>
//                         {" "}
//                         <em>Select...</em>{" "}
//                       </MenuItem>
//                       <MenuItem value="full-time">Full-time</MenuItem>
//                       <MenuItem value="part-time">Part-time</MenuItem>
//                       <MenuItem value="contract">Contract</MenuItem>
//                       <MenuItem value="freelance">Freelance</MenuItem>
//                     </Select>
//                   </FormControl>
//                   <FormControl fullWidth>
//                     <InputLabel id="experience-level-select-label">
//                       Experience Level
//                     </InputLabel>
//                     <Select
//                       labelId="experience-level-select-label"
//                       value={jobData.experience}
//                       label="Experience Level"
//                       onChange={(e) =>
//                         handleInputChange("experience", e.target.value)
//                       }
//                     >
//                       <MenuItem value="" disabled>
//                         {" "}
//                         <em>Select...</em>{" "}
//                       </MenuItem>
//                       <MenuItem value="entry">Entry Level (0-2 years)</MenuItem>
//                       <MenuItem value="mid">Mid Level (3-5 years)</MenuItem>
//                       <MenuItem value="senior">
//                         Senior Level (5+ years)
//                       </MenuItem>
//                       <MenuItem value="lead">
//                         Lead/Principal (8+ years)
//                       </MenuItem>
//                     </Select>
//                   </FormControl>
//                   <TextField
//                     fullWidth
//                     label="Contact Email"
//                     value={jobData.contactEmail}
//                     onChange={(e) =>
//                       handleInputChange("contactEmail", e.target.value)
//                     }
//                   />
//                 </Box>
//               </Box>

//               <Divider />

//               <Box>
//                 <SectionTitle>Salary Information</SectionTitle>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} sm={4}>
//                     <FormControl fullWidth>
//                       <InputLabel id="currency-label">Currency</InputLabel>
//                       <Select
//                         labelId="currency-label"
//                         label="Currency"
//                         value={jobData.currency}
//                         onChange={(e) =>
//                           handleInputChange("currency", e.target.value)
//                         }
//                         disabled={isCurrenciesLoading}
//                       >
//                         {isCurrenciesLoading ? (
//                           <MenuItem value={jobData.currency}>
//                             <em>Loading currencies...</em>
//                           </MenuItem>
//                         ) : (
//                           currencies.map((currency) => (
//                             <MenuItem key={currency.code} value={currency.code}>
//                               {currency.code} ({currency.name})
//                             </MenuItem>
//                           ))
//                         )}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       fullWidth
//                       type="number"
//                       label="Minimum Salary"
//                       value={jobData.salaryMin}
//                       onChange={(e) =>
//                         handleInputChange("salaryMin", e.target.value)
//                       }
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       fullWidth
//                       type="number"
//                       label="Maximum Salary"
//                       value={jobData.salaryMax}
//                       onChange={(e) =>
//                         handleInputChange("salaryMax", e.target.value)
//                       }
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>

//               <Divider />

//               <Box>
//                 <SectionTitle>Job Description</SectionTitle>
//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={6}
//                   label="Detailed Job Description*"
//                   value={jobData.description}
//                   onChange={(e) =>
//                     handleInputChange("description", e.target.value)
//                   }
//                 />
//               </Box>

//               <Grid container spacing={4}>
//                 <Grid item xs={12} md={6}>
//                   <SectionTitle>Requirements</SectionTitle>
//                   <Stack spacing={2}>
//                     <Stack direction="row" spacing={1} alignItems="center">
//                       <TextField
//                         fullWidth
//                         label="Add Requirement"
//                         value={newRequirement}
//                         onChange={(e) => setNewRequirement(e.target.value)}
//                         onKeyPress={(e) =>
//                           e.key === "Enter" &&
//                           handleAddItem(
//                             "requirements",
//                             newRequirement,
//                             setNewRequirement
//                           )
//                         }
//                       />
//                       <Button
//                         variant="contained"
//                         onClick={() =>
//                           handleAddItem(
//                             "requirements",
//                             newRequirement,
//                             setNewRequirement
//                           )
//                         }
//                         sx={{ height: "fit-content", padding: "10px" }}
//                       >
//                         <Add />
//                       </Button>
//                     </Stack>
//                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                       {jobData.requirements.map((req, index) => (
//                         <Chip
//                           key={index}
//                           label={req}
//                           onDelete={() =>
//                             handleRemoveItem("requirements", index)
//                           }
//                         />
//                       ))}
//                     </Box>
//                   </Stack>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <SectionTitle>Benefits</SectionTitle>
//                   <Stack spacing={2}>
//                     <Stack direction="row" spacing={1} alignItems="center">
//                       <TextField
//                         fullWidth
//                         label="Add Benefit"
//                         value={newBenefit}
//                         onChange={(e) => setNewBenefit(e.target.value)}
//                         onKeyPress={(e) =>
//                           e.key === "Enter" &&
//                           handleAddItem("benefits", newBenefit, setNewBenefit)
//                         }
//                       />
//                       <Button
//                         variant="contained"
//                         onClick={() =>
//                           handleAddItem("benefits", newBenefit, setNewBenefit)
//                         }
//                         sx={{ height: "fit-content", padding: "10px" }}
//                       >
//                         <Add />
//                       </Button>
//                     </Stack>
//                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                       {jobData.benefits.map((benefit, index) => (
//                         <Chip
//                           key={index}
//                           label={benefit}
//                           onDelete={() => handleRemoveItem("benefits", index)}
//                         />
//                       ))}
//                     </Box>
//                   </Stack>
//                 </Grid>
//               </Grid>

//               <Box>
//                 <SectionTitle>Required Skills</SectionTitle>
//                 <Stack spacing={2}>
//                   <FormControl fullWidth>
//                     <InputLabel id="skill-select-label">
//                       Select from common skills...
//                     </InputLabel>
//                     <Select
//                       labelId="skill-select-label"
//                       label="Select from common skills..."
//                       value=""
//                       onChange={(e) => handleSkillAdd(e.target.value)}
//                     >
//                       {skillOptions.map((skill) => (
//                         <MenuItem key={skill} value={skill}>
//                           {skill}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                   <Stack direction="row" spacing={1} alignItems="center">
//                     <TextField
//                       fullWidth
//                       label="Or add a custom skill"
//                       value={newSkill}
//                       onChange={(e) => setNewSkill(e.target.value)}
//                       onKeyPress={(e) => {
//                         if (e.key === "Enter") {
//                           handleSkillAdd(newSkill);
//                           setNewSkill("");
//                         }
//                       }}
//                     />
//                     <Button
//                       variant="contained"
//                       onClick={() => {
//                         handleSkillAdd(newSkill);
//                         setNewSkill("");
//                       }}
//                       sx={{ height: "fit-content", padding: "10px" }}
//                     >
//                       <Add />
//                     </Button>
//                   </Stack>
//                   <Box
//                     sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 1 }}
//                   >
//                     {jobData.skills.map((skill, index) => (
//                       <Chip
//                         key={index}
//                         label={skill}
//                         onDelete={() => handleRemoveItem("skills", index)}
//                       />
//                     ))}
//                   </Box>
//                 </Stack>
//               </Box>

//               <Divider />

//               <Box>
//                 <SectionTitle>Additional Information</SectionTitle>
//                 <Grid container spacing={3} alignItems="center">
//                   <Grid item xs={12} md={4}>
//                     <LocalizationProvider dateAdapter={AdapterDateFns}>
//                       <DatePicker
//                         label="Application Deadline"
//                         value={jobData.applicationDeadline}
//                         onChange={(newValue) =>
//                           handleInputChange("applicationDeadline", newValue)
//                         }
//                         slotProps={{ textField: { fullWidth: true } }}
//                       />
//                     </LocalizationProvider>
//                   </Grid>
//                   <Grid item xs={12} md={8}>
//                     <Stack direction="row" spacing={2} flexWrap="wrap">
//                       <Button
//                         variant={
//                           jobData.visaSponsorship ? "contained" : "outlined"
//                         }
//                         onClick={() =>
//                           handleInputChange(
//                             "visaSponsorship",
//                             !jobData.visaSponsorship
//                           )
//                         }
//                       >
//                         Visa Sponsorship
//                       </Button>
//                       <Button
//                         variant={jobData.remoteWork ? "contained" : "outlined"}
//                         onClick={() =>
//                           handleInputChange("remoteWork", !jobData.remoteWork)
//                         }
//                       >
//                         Remote Work
//                       </Button>
//                     </Stack>
//                   </Grid>
//                 </Grid>
//               </Box>

//               <Stack
//                 direction={{ xs: "column-reverse", sm: "row" }}
//                 spacing={2}
//                 justifyContent="flex-end"
//                 alignItems="center"
//                 sx={{ pt: 3 }}
//               >
//                 <Stack
//                   direction={{ xs: "column", sm: "row" }}
//                   spacing={2}
//                   sx={{ width: { xs: "100%", sm: "auto" } }}
//                 >
//                   <Button
//                     variant="outlined"
//                     color="secondary"
//                     startIcon={<Visibility />}
//                     onClick={() => setIsPreviewing(true)}
//                   >
//                     Preview
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     color="primary"
//                     startIcon={<Save />}
//                     disabled={loading}
//                     onClick={() => handleSubmit("DRAFT")}
//                   >
//                     Save as Draft
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     startIcon={
//                       loading ? (
//                         <CircularProgress size={20} color="inherit" />
//                       ) : (
//                         <Save />
//                       )
//                     }
//                     onClick={() => handleSubmit("PUBLISHED")}
//                     disabled={loading}
//                   >
//                     Post Job
//                   </Button>
//                 </Stack>
//               </Stack>
//             </Stack>
//           </Paper>
//         </Stack>
//       </Container>
//     </Layout>
//   );
// };

// export default JobPosting;





"use client";

import { useState, useEffect, useCallback } from "react";
import apiClient from "../../context/apiClient";

import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  Select,
  MenuItem,
  Chip,
  Divider,
  Paper,
  CircularProgress,
  Container,
  Stack,
  InputLabel,
  Skeleton,
  Autocomplete,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Add, Edit, Save, Visibility } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Layout from "../common/Layout";
import { useNotification } from "../../context/NotificationContext";
import { debounce } from "lodash";

const JobPosting = () => {
  const theme = useTheme();
  const { showNotification } = useNotification();

  const initialJobData = {
    title: "",
    companyName: "",
    contactEmail: "",
    location: "",
    jobType: "",
    experience: "",
    salaryMin: "",
    salaryMax: "",
    currency: "USD",
    description: "",
    requirements: [],
    benefits: [],
    skills: [],
    applicationDeadline: null,
    visaSponsorship: false,
    remoteWork: false,
  };

  const [loading, setLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isPreviewing, setIsPreviewing] = useState(false);
  const [jobData, setJobData] = useState(initialJobData);
  const [newRequirement, setNewRequirement] = useState("");
  const [newBenefit, setNewBenefit] = useState("");
  const [newSkill, setNewSkill] = useState("");
  const [errors, setErrors] = useState({}); // State to hold validation errors

  // --- Location autocomplete logic ---
  const [locationOptions, setLocationOptions] = useState([]);
  const [isLocationLoading, setIsLocationLoading] = useState(false);
  const GEONAMES_USERNAME = "jobhustle";

  const fetchLocations = async (query) => {
    if (query.length < 2) {
      setLocationOptions([]);
      return;
    }
    setIsLocationLoading(true);
    try {
      const response = await fetch(
        `http://api.geonames.org/searchJSON?q=${query}&maxRows=5&featureClass=P&username=${GEONAMES_USERNAME}`
      );
      const data = await response.json();
      if (data.geonames) {
        const formattedOptions = data.geonames.map(
          (item) => `${item.name}, ${item.countryName}`
        );
        setLocationOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Failed to fetch locations:", error);
    } finally {
      setIsLocationLoading(false);
    }
  };

  const debouncedFetchLocations = useCallback(
    debounce(fetchLocations, 300),
    []
  );
  // --- End of location logic ---

  // --- CURRENCY API INTEGRATION START ---
  const [currencies, setCurrencies] = useState([]);
  const [isCurrenciesLoading, setIsCurrenciesLoading] = useState(true);

  useEffect(() => {
    const fetchCurrencies = async () => {
      // Define the preferred currency codes in the desired order
      const preferredOrder = ["USD", "EUR", "GBP", "AED", "SGD"];

      try {
        const response = await fetch("https://api.frankfurter.app/currencies");
        const data = await response.json();
        const allCurrencies = Object.entries(data).map(([code, name]) => ({
          code,
          name,
        }));

        // Separate preferred currencies from the rest
        const preferred = [];
        const others = [];

        allCurrencies.forEach((currency) => {
          if (preferredOrder.includes(currency.code)) {
            preferred.push(currency);
          } else {
            others.push(currency);
          }
        });

        // Sort the preferred currencies according to the preferredOrder array
        preferred.sort(
          (a, b) => preferredOrder.indexOf(a.code) - preferredOrder.indexOf(b.code)
        );

        // Sort the rest of the currencies alphabetically by name
        others.sort((a, b) => a.name.localeCompare(b.name));

        // Combine the lists and set the state
        setCurrencies([...preferred, ...others]);
      } catch (error) {
        console.error("Failed to fetch currencies:", error);
        // Fallback to a basic list (already in the desired order)
        setCurrencies([
          { code: "USD", name: "United States Dollar" },
          { code: "EUR", name: "Euro" },
          { code: "GBP", name: "British Pound Sterling" },
          { code: "AED", name: "United Arab Emirates Dirham" },
          { code: "SGD", name: "Singapore Dollar" },
        ]);
      } finally {
        setIsCurrenciesLoading(false);
      }
    };

    fetchCurrencies();
  }, []); // Empty dependency array means this runs once on mount
  // --- CURRENCY API INTEGRATION END ---

  useEffect(() => {
    const timer = setTimeout(() => setIsPageLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const skillOptions = [
    "Python",
    "Machine Learning",
    "Deep Learning",
    "TensorFlow",
    "PyTorch",
    "NLP",
    "Computer Vision",
    "Data Science",
    "AWS",
    "Azure",
    "GCP",
    "Kubernetes",
    "Docker",
    "React",
    "Node.js",
    "SQL",
    "NoSQL",
  ];

  const jobTypeDisplayMapping = {
    "full-time": "Full-time",
    "part-time": "Part-time",
    contract: "Contract",
    freelance: "Freelance",
  };

  const experienceDisplayMapping = {
    entry: "Entry Level (0-2 years)",
    mid: "Mid Level (3-5 years)",
    senior: "Senior Level (5+ years)",
    lead: "Lead/Principal (8+ years)",
  };

  const handleInputChange = (field, value) => {
    // --- Validation Logic ---
    const newErrors = { ...errors };
    switch (field) {
      case "title":
      case "companyName":
        if (value && !/^[a-zA-Z\s'-]+$/.test(value)) {
          newErrors[field] =
            "Only characters, spaces, hyphens, and apostrophes are allowed.";
        } else {
          delete newErrors[field];
        }
        break;
      case "location":
        if (value && !/^[a-zA-Z0-9\s,.-]+$/.test(value)) {
          newErrors[field] = "Location contains invalid characters.";
        } else {
          delete newErrors[field];
        }
        break;
      case "contactEmail":
        if (value && !/^\S+@\S+\.\S+$/.test(value)) {
          newErrors[field] = "Please enter a valid email address.";
        } else {
          delete newErrors[field];
        }
        break;
      default:
        break;
    }
    setErrors(newErrors);

    setJobData((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddItem = (field, value, setter) => {
    if (value.trim()) {
      setJobData((prev) => ({
        ...prev,
        [field]: [...prev[field], value.trim()],
      }));
      setter("");
    }
  };

  const handleSkillAdd = (skill) => {
    if (skill && !jobData.skills.includes(skill)) {
      setJobData((prev) => ({ ...prev, skills: [...prev.skills, skill] }));
    }
  };

  const handleRemoveItem = (field, index) =>
    setJobData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));

  const handleSubmit = async (status) => {
    // Check for existing validation errors before submitting
    const hasErrors = Object.values(errors).some((error) => !!error);
    if (hasErrors) {
      showNotification("Please correct the highlighted errors.", "error");
      return;
    }

    if (!jobData.title || !jobData.location || !jobData.description) {
      showNotification(
        "Please fill in all required fields: Title, Location, and Description",
        "error"
      );
      return;
    }
    if (!jobData.jobType || !jobData.experience) {
      showNotification(
        "Please select a Job Type and Experience Level.",
        "error"
      );
      return;
    }

    setLoading(true);
    const deadline = jobData.applicationDeadline
      ? new Date(jobData.applicationDeadline).toISOString().split("T")[0]
      : null;

    const payload = {
      title: jobData.title,
      description: jobData.description,
      responsibilities: jobData.description,
      requirements: jobData.requirements,
      location: jobData.location,
      job_type: jobTypeDisplayMapping[jobData.jobType],
      experience_level: {
        entry: "Entry-level",
        mid: "Mid-level",
        senior: "Senior-level",
        lead: "Lead/Principal",
      }[jobData.experience],
      salary_currency: jobData.currency,
      salary_min: jobData.salaryMin ? parseFloat(jobData.salaryMin) : null,
      salary_max: jobData.salaryMax ? parseFloat(jobData.salaryMax) : null,
      benefits: jobData.benefits,
      required_skills: jobData.skills,
      visa_sponsorship: jobData.visaSponsorship,
      remote_work: jobData.remoteWork,
      status: status,
      application_deadline: deadline,
    };

    try {
      await apiClient.post("/job-postings/", payload);
      showNotification(
        status === "DRAFT" ? "Job saved as draft!" : "Job posted successfully!",
        "success"
      );
      if (status === "PUBLISHED") setIsPreviewing(false);
      setJobData(initialJobData);
      setNewRequirement("");
      setNewBenefit("");
      setNewSkill("");
    } catch (error) {
      console.error("Failed to post job:", error);
      let errorMessage = "Failed to post job.";
      if (error.response?.data) {
        const errors = error.response.data;
        const firstErrorKey = Object.keys(errors)[0];
        errorMessage = `${firstErrorKey}: ${
          Array.isArray(errors[firstErrorKey])
            ? errors[firstErrorKey][0]
            : errors[firstErrorKey]
        }`;
      }
      showNotification(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  const SectionTitle = ({ children }) => (
    <Typography
      variant="h6"
      fontWeight="bold"
      sx={{ color: "primary.main", mb: 2 }}
    >
      {children}
    </Typography>
  );

  const formPaperStyles = {
    p: { xs: 2, md: 4 },
    borderRadius: "12px",
    backgroundColor: theme.palette.mint.main,
    boxShadow: theme.shadows[1],
  };

  if (isPageLoading) {
    return (
      <Layout title="Post New Job">
        <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
          <Stack spacing={4}>
            <Skeleton
              variant="rectangular"
              height={100}
              sx={{ borderRadius: "12px" }}
            />
            <Skeleton
              variant="rectangular"
              height={600}
              sx={{ borderRadius: "12px" }}
            />
          </Stack>
        </Container>
      </Layout>
    );
  }

  if (isPreviewing) {
    return (
      <Layout title="Preview Job Posting">
        <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
          <Paper elevation={0} sx={formPaperStyles}>
            <Stack spacing={4}>
              <Box>
                <Typography variant="h4" component="h1" fontWeight="bold">
                  {jobData.title || "Job Title"}
                </Typography>
                <Typography variant="h6" color="text.secondary">
                  {jobData.companyName || "Company Name"} -{" "}
                  {jobData.location || "Location"}
                </Typography>
              </Box>
              <Divider />
              <Box>
                <SectionTitle>Job Description</SectionTitle>
                <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
                  {jobData.description}
                </Typography>
              </Box>
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <SectionTitle>Requirements</SectionTitle>
                  <Stack spacing={1}>
                    {jobData.requirements.length > 0 ? (
                      jobData.requirements.map((item, index) => (
                        <Typography key={index} variant="body1">
                          {" "}
                          • {item}{" "}
                        </Typography>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No requirements listed.
                      </Typography>
                    )}
                  </Stack>
                </Grid>
                <Grid item xs={12} md={6}>
                  <SectionTitle>Benefits</SectionTitle>
                  <Stack spacing={1}>
                    {jobData.benefits.length > 0 ? (
                      jobData.benefits.map((item, index) => (
                        <Typography key={index} variant="body1">
                          {" "}
                          • {item}{" "}
                        </Typography>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No benefits listed.
                      </Typography>
                    )}
                  </Stack>
                </Grid>
              </Grid>
              <Box>
                <SectionTitle>Required Skills</SectionTitle>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {jobData.skills.length > 0 ? (
                    jobData.skills.map((skill, index) => (
                      <Chip key={index} label={skill} />
                    ))
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No skills listed.
                    </Typography>
                  )}
                </Box>
              </Box>
              <Divider />
              <Box>
                <SectionTitle>Additional Information</SectionTitle>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography fontWeight="bold">Job Type:</Typography>
                    <Typography>
                      {jobTypeDisplayMapping[jobData.jobType] ||
                        "Not Specified"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography fontWeight="bold">Experience Level:</Typography>
                    <Typography>
                      {experienceDisplayMapping[jobData.experience] ||
                        "Not Specified"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography fontWeight="bold">Salary:</Typography>
                    <Typography>
                      {jobData.salaryMin && jobData.salaryMax
                        ? `${jobData.salaryMin} - ${jobData.salaryMax} ${jobData.currency}`
                        : "Not Disclosed"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography fontWeight="bold">
                      Application Deadline:
                    </Typography>
                    <Typography>
                      {jobData.applicationDeadline
                        ? new Date(
                            jobData.applicationDeadline
                          ).toLocaleDateString()
                        : "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <b>Visa Sponsorship:</b>{" "}
                      {jobData.visaSponsorship ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <b>Remote Work:</b> {jobData.remoteWork ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="flex-end"
                sx={{ pt: 3 }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<Edit />}
                  onClick={() => setIsPreviewing(false)}
                >
                  {" "}
                  Back to Edit{" "}
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<Save />}
                  disabled={loading}
                  onClick={() => handleSubmit("DRAFT")}
                >
                  {" "}
                  Save as Draft{" "}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={
                    loading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <Save />
                    )
                  }
                  disabled={loading}
                  onClick={() => handleSubmit("PUBLISHED")}
                >
                  {" "}
                  Publish Job{" "}
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </Container>
      </Layout>
    );
  }

  return (
    <Layout title="Post New Job">
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 4 } }}>
        <Stack spacing={4}>
          <Paper elevation={0} sx={formPaperStyles}>
            <Typography
              variant="h4"
              component="h1"
              fontWeight="bold"
              color="primary.main"
            >
              Create a New Job Posting
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
              Fill in the details below to find the best AI talent for your
              project.
            </Typography>
          </Paper>

          <Paper elevation={0} sx={formPaperStyles}>
            <Stack spacing={4}>
              <Box>
                <SectionTitle>Basic Information</SectionTitle>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      md: "repeat(3, 1fr)",
                    },
                    gap: 3,
                  }}
                >
                  <TextField
                    fullWidth
                    label="Job Title"
                    value={jobData.title}
                    onChange={(e) => handleInputChange("title", e.target.value)}
                    error={!!errors.title}
                    helperText={errors.title}
                  />
                  <TextField
                    fullWidth
                    label="Company Name"
                    value={jobData.companyName}
                    onChange={(e) =>
                      handleInputChange("companyName", e.target.value)
                    }
                    error={!!errors.companyName}
                    helperText={errors.companyName}
                  />
                  <Autocomplete
                    fullWidth
                    options={locationOptions}
                    loading={isLocationLoading}
                    freeSolo
                    value={jobData.location}
                    onInputChange={(event, newInputValue) => {
                      handleInputChange("location", newInputValue);
                      debouncedFetchLocations(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                      handleInputChange("location", newValue || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Location"
                        error={!!errors.location}
                        helperText={errors.location}
                      />
                    )}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="job-type-select-label">Job Type</InputLabel>
                    <Select
                      labelId="job-type-select-label"
                      value={jobData.jobType}
                      label="Job Type"
                      onChange={(e) =>
                        handleInputChange("jobType", e.target.value)
                      }
                    >
                      <MenuItem value="" disabled>
                        {" "}
                        <em>Select...</em>{" "}
                      </MenuItem>
                      <MenuItem value="full-time">Full-time</MenuItem>
                      <MenuItem value="part-time">Part-time</MenuItem>
                      <MenuItem value="contract">Contract</MenuItem>
                      <MenuItem value="freelance">Freelance</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="experience-level-select-label">
                      Experience Level
                    </InputLabel>
                    <Select
                      labelId="experience-level-select-label"
                      value={jobData.experience}
                      label="Experience Level"
                      onChange={(e) =>
                        handleInputChange("experience", e.target.value)
                      }
                    >
                      <MenuItem value="" disabled>
                        {" "}
                        <em>Select...</em>{" "}
                      </MenuItem>
                      <MenuItem value="entry">Entry Level (0-2 years)</MenuItem>
                      <MenuItem value="mid">Mid Level (3-5 years)</MenuItem>
                      <MenuItem value="senior">
                        Senior Level (5+ years)
                      </MenuItem>
                      <MenuItem value="lead">
                        Lead/Principal (8+ years)
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Contact Email"
                    value={jobData.contactEmail}
                    onChange={(e) =>
                      handleInputChange("contactEmail", e.target.value)
                    }
                    error={!!errors.contactEmail}
                    helperText={errors.contactEmail}
                  />
                </Box>
              </Box>

              <Divider />

              <Box>
                <SectionTitle>Salary Information</SectionTitle>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                      <InputLabel id="currency-label">Currency</InputLabel>
                      <Select
                        labelId="currency-label"
                        label="Currency"
                        value={jobData.currency}
                        onChange={(e) =>
                          handleInputChange("currency", e.target.value)
                        }
                        disabled={isCurrenciesLoading}
                      >
                        {isCurrenciesLoading ? (
                          <MenuItem value={jobData.currency}>
                            <em>Loading currencies...</em>
                          </MenuItem>
                        ) : (
                          currencies.map((currency) => (
                            <MenuItem key={currency.code} value={currency.code}>
                              {currency.code} ({currency.name})
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Minimum Salary"
                      value={jobData.salaryMin}
                      onChange={(e) =>
                        handleInputChange("salaryMin", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Maximum Salary"
                      value={jobData.salaryMax}
                      onChange={(e) =>
                        handleInputChange("salaryMax", e.target.value)
                      }
                    />
                  </Grid>
                </Grid>
              </Box>

              <Divider />

              <Box>
                <SectionTitle>Job Description</SectionTitle>
                <TextField
                  fullWidth
                  multiline
                  rows={6}
                  label="Detailed Job Description*"
                  value={jobData.description}
                  onChange={(e) =>
                    handleInputChange("description", e.target.value)
                  }
                />
              </Box>

              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <SectionTitle>Requirements</SectionTitle>
                  <Stack spacing={2}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <TextField
                        fullWidth
                        label="Add Requirement"
                        value={newRequirement}
                        onChange={(e) => setNewRequirement(e.target.value)}
                        onKeyPress={(e) =>
                          e.key === "Enter" &&
                          handleAddItem(
                            "requirements",
                            newRequirement,
                            setNewRequirement
                          )
                        }
                      />
                      <Button
                        variant="contained"
                        onClick={() =>
                          handleAddItem(
                            "requirements",
                            newRequirement,
                            setNewRequirement
                          )
                        }
                        sx={{ height: "fit-content", padding: "10px" }}
                      >
                        <Add />
                      </Button>
                    </Stack>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {jobData.requirements.map((req, index) => (
                        <Chip
                          key={index}
                          label={req}
                          onDelete={() =>
                            handleRemoveItem("requirements", index)
                          }
                        />
                      ))}
                    </Box>
                  </Stack>
                </Grid>

                <Grid item xs={12} md={6}>
                  <SectionTitle>Benefits</SectionTitle>
                  <Stack spacing={2}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <TextField
                        fullWidth
                        label="Add Benefit"
                        value={newBenefit}
                        onChange={(e) => setNewBenefit(e.target.value)}
                        onKeyPress={(e) =>
                          e.key === "Enter" &&
                          handleAddItem("benefits", newBenefit, setNewBenefit)
                        }
                      />
                      <Button
                        variant="contained"
                        onClick={() =>
                          handleAddItem("benefits", newBenefit, setNewBenefit)
                        }
                        sx={{ height: "fit-content", padding: "10px" }}
                      >
                        <Add />
                      </Button>
                    </Stack>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {jobData.benefits.map((benefit, index) => (
                        <Chip
                          key={index}
                          label={benefit}
                          onDelete={() => handleRemoveItem("benefits", index)}
                        />
                      ))}
                    </Box>
                  </Stack>
                </Grid>
              </Grid>

              <Box>
                <SectionTitle>Required Skills</SectionTitle>
                <Stack spacing={2}>
                  <FormControl fullWidth>
                    <InputLabel id="skill-select-label">
                      Select from common skills...
                    </InputLabel>
                    <Select
                      labelId="skill-select-label"
                      label="Select from common skills..."
                      value=""
                      onChange={(e) => handleSkillAdd(e.target.value)}
                    >
                      {skillOptions.map((skill) => (
                        <MenuItem key={skill} value={skill}>
                          {skill}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TextField
                      fullWidth
                      label="Or add a custom skill"
                      value={newSkill}
                      onChange={(e) => setNewSkill(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          handleSkillAdd(newSkill);
                          setNewSkill("");
                        }
                      }}
                    />
                    <Button
                      variant="contained"
                      onClick={() => {
                        handleSkillAdd(newSkill);
                        setNewSkill("");
                      }}
                      sx={{ height: "fit-content", padding: "10px" }}
                    >
                      <Add />
                    </Button>
                  </Stack>
                  <Box
                    sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 1 }}
                  >
                    {jobData.skills.map((skill, index) => (
                      <Chip
                        key={index}
                        label={skill}
                        onDelete={() => handleRemoveItem("skills", index)}
                      />
                    ))}
                  </Box>
                </Stack>
              </Box>

              <Divider />

              <Box>
                <SectionTitle>Additional Information</SectionTitle>
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Application Deadline"
                        value={jobData.applicationDeadline}
                        onChange={(newValue) =>
                          handleInputChange("applicationDeadline", newValue)
                        }
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Stack direction="row" spacing={2} flexWrap="wrap">
                      <Button
                        variant={
                          jobData.visaSponsorship ? "contained" : "outlined"
                        }
                        onClick={() =>
                          handleInputChange(
                            "visaSponsorship",
                            !jobData.visaSponsorship
                          )
                        }
                      >
                        Visa Sponsorship
                      </Button>
                      <Button
                        variant={jobData.remoteWork ? "contained" : "outlined"}
                        onClick={() =>
                          handleInputChange("remoteWork", !jobData.remoteWork)
                        }
                      >
                        Remote Work
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Stack
                direction={{ xs: "column-reverse", sm: "row" }}
                spacing={2}
                justifyContent="flex-end"
                alignItems="center"
                sx={{ pt: 3 }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<Visibility />}
                    onClick={() => setIsPreviewing(true)}
                  >
                    Preview
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<Save />}
                    disabled={loading}
                    onClick={() => handleSubmit("DRAFT")}
                  >
                    Save as Draft
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={
                      loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <Save />
                      )
                    }
                    onClick={() => handleSubmit("PUBLISHED")}
                    disabled={loading}
                  >
                    Post Job
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </Paper>
        </Stack>
      </Container>
    </Layout>
  );
};

export default JobPosting;